import {
    fetchAll,
    fetchFiltered,
    add,
    edit,
    show
} from '@/api/vehiclebrands'

const state = {
  all: [],
  isLoading: false,
  vehicleBrandById: null
}

const getters = {}

const actions = {
  cleanState ({ commit }) {
    commit('cleanState')
  },

  async fetchById ({ dispatch, commit }, id) {
    try {
      const vehicleBrand = await show(id)
      commit('setVehicleBrandById', vehicleBrand)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchAll ({ dispatch, commit }) {
    try {
      const vehicleBrands = await fetchAll()
      commit('setAll', vehicleBrands)
    } catch (e) {
      dispatch('notify/success', e.message, { root: true })
    }
  },

  async fetchFiltered ({ dispatch, commit }, queriesParams) {
    try {
      const vehicleBrands = await fetchFiltered(queriesParams)
      commit('setAll', vehicleBrands)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async edit ({ dispatch, commit }, { id, data }) {
    commit('setLoading', true)
    try {
      await edit(id, data)
      return true
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    } finally {
      commit('setLoading', false)
    }
    return false
  },

  async create ({ dispatch, commit }, user) {
    commit('setLoading', true)
    try {
      await add(user)
      return true
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    } finally {
      commit('setLoading', false)
    }
    return false
  }
}

const mutations = {
  cleanState (state) {
    state.all = []
    state.isLoading = false
    state.vehicleBrandById = null
  },

  setVehicleBrandById (state, vehicleBrand) {
    const { name, id } = vehicleBrand
    state.vehicleBrandById = { name, id }
  },

  setAll (state, vehicleBrands) {
    state.all = vehicleBrands
  },

  setLoading (state, isLoading) {
    state.isLoading = isLoading
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}